var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-component',{attrs:{"model":_vm.model,"show-form":false,"url-create-form":"/roles/new","url-edit-form":"/roles/edit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }